import { render, staticRenderFns } from "./QScoreCardAverageDaysToSubmit.vue?vue&type=template&id=1fe5427e&scoped=true&"
import script from "./QScoreCardAverageDaysToSubmit.vue?vue&type=script&lang=js&"
export * from "./QScoreCardAverageDaysToSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe5427e",
  null
  
)

export default component.exports